import React, { FC, useRef } from 'react';
import { IFileDownloadExperienceSearch } from './types';
import {
  FlexGrid,
  SearchInput,
  Sizes,
  Typography,
  VerticalSpacing,
  VerticalSpacingSizes,
  getClassNameFactory,
} from '@dcl/ui';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import './FileDownloadExperienceSearch.css';

export const FileDownloadExperienceSearch: FC<IFileDownloadExperienceSearch> = (
  props
) => {
  const { searchTitle, handleSearch, handleClearSearch } = props;
  const getClassName = getClassNameFactory(
    FileDownloadExperienceSearch.displayName
  );
  const inputSearchRef = useRef<SearchInput>();

  return (
    <div className={getClassName()}>
      <VerticalSpacing size={VerticalSpacingSizes.S}> </VerticalSpacing>
      <FlexGrid>
        <FlexGrid.Row className={getClassName({ descendantName: 'flexRow' })}>
          <FlexGrid.Col
            md={3}
            lg={3}
            sm={12}
            className={getClassName({ descendantName: 'searchTitle' })}
          >
            <Typography type={Sizes.XXTRASMALL} tag={TypographyTags.SPAN}>
              {searchTitle}
            </Typography>
          </FlexGrid.Col>
          <FlexGrid.Col
            md={9}
            lg={9}
            sm={12}
            className={getClassName({ descendantName: 'searchBox' })}
          >
            <SearchInput
              ref={inputSearchRef}
              placeholder={''}
              typeahead={false}
              value={''}
              colorTheme="orange"
              onSubmit={(searchValue: string) => handleSearch(searchValue)}
              data-testid="searchInputBox"
              onClear={() => handleClearSearch()}
              allowEmptyInput={true}
            />
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
    </div>
  );
};

FileDownloadExperienceSearch.displayName = 'FileDownloadExperienceSearch';
